import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import Profile from "@/pages/Profile";

export const Route = createFileRoute("/cuenta/perfil")({
  head: () => ({
    meta: [
      { title: "Mi perfil | Retail Lemon" },
      { name: "description", content: "Gestiona los datos y preferencias de tu cuenta de Retail Lemon." },
      { property: "og:title", content: "Mi perfil | Retail Lemon" },
      { property: "og:description", content: "Gestiona los datos y preferencias de tu cuenta de Retail Lemon." },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => (
    <ProtectedRoute>
      <Profile />
    </ProtectedRoute>
  ),
});
